import { computePosition, flip, shift, offset, autoUpdate } from '@floating-ui/dom';

// directives
import onClickOutside from '@/directives/onClickOutside';

// utils
import { getRef } from '@/utils/getRef';
export default {
  directives: {
    onClickOutside
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    placement: {
      type: String,
      default: 'bottom-end'
    }
  },
  data() {
    return {
      cleanup: null
    };
  },
  methods: {
    async getElements() {
      await this.$nextTick();
      const [button, popper] = await Promise.all([getRef.call(this, 'button'), getRef.call(this, 'popper')]);
      return {
        button,
        popper
      };
    },
    async update() {
      const {
        popper,
        button
      } = await this.getElements();
      const {
        x,
        y
      } = await computePosition(button, popper, {
        placement: this.placement,
        middleware: [flip(), shift(), offset(3)]
      });
      Object.assign(popper.style, {
        left: `${x}px`,
        top: `${y}px`
      });
    },
    async show() {
      const {
        popper
      } = await this.getElements();
      this.update();
      await this.$nextTick();
      if (!this.cleanup) {
        await this.autoUpdate();
      }
      popper.style.display = 'block';
    },
    async toggle() {
      const {
        popper
      } = await this.getElements();
      const isVisible = popper.style.display === 'block';
      if (isVisible) {
        this.hide();
      } else {
        this.show();
      }
    },
    async hide() {
      const {
        popper
      } = await this.getElements();
      popper.style.display = 'none';
      if (this.cleanup) {
        this.cleanup();
        this.cleanup = null;
      }
    },
    async autoUpdate() {
      const {
        popper,
        button
      } = await this.getElements();
      this.cleanup = autoUpdate(button, popper, this.update);
    }
  }
};